<template>
  <div>
    <!-- 私密货盘商品一键导入-->
    <el-dialog :title="!success ? $t('message.privateInventoryProductOneClickImport') : '导入结果页面'"
      :close-on-click-modal="false" :visible.sync="dialogVisible" width="488px" center>
      <div v-if="!success">
        <div class="prompt">请选择上传文件。</div>
        <div class="content">
          <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" multiple
            :before-upload="befoUpload" :http-request="httpFile" :file-list="fileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">*文件的格式是XIs，XIsx </div>
          </el-upload>
        </div>
      </div>
      <div v-else class="success">
        <p> 文档共获取商品链接：{{ successNum.all }} 个</p>
        <p> 成功导入商品个数： <b>{{ successNum.success }} </b> 个</p>
        <p> 失败导入商品个数： <b style="color: red;">{{ successNum.error }} </b> 个</p>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!success">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 导入 -->
        <el-button type="primary" @click="importProduct">{{
          $t("message.import")
        }}</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-else>
        <!-- 确定 -->
        <el-button type="primary" @click="dialogVisible = false">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      success: false,
      successNum: {
        all: 0,
        success: 0,
        error: 0
      },
    };
  },
  methods: {
    //一键导入商品
    importProduct() {
      let datas = {
        file: this.fileList[0].url
      }
      if (this.fileList == false) return this.$message.error('请选择上传文件')
      this.$api.siteConfiguration.importProduct(datas).then(res => {
        this.$message.success(res.msg)
        this.fileList = []
        this.success = true
        this.successNum = res.data
        this.$parent.rakuProductList()
      })
    },
    // 上传
    async httpFile(file) {
      let data = await this.createClient(file)
      this.fileList = [{ url: data.data, name: file.file.name }]
      this.$forceUpdate()
    },
    // 上传前
    befoUpload(file) {
      const xlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const xls = file.type === "application/vnd.ms-excel";
      // const csv = file.type === "text/csv";
      if (!xlsx && !xls) {
        this.$message.error("只能上传.xls或者.xlsx");
      }
      return xlsx || xls;
    },
  },
};
</script>
<style lang='scss' scoped>
.prompt {
  padding-left: 20px;
  margin-bottom: 20px;
}

.content {
  margin: 0px 15px;
  display: flex;
  justify-content: center;
  align-items: center;

  li {
    padding: 0 15px;
    flex: 1.5;
  }

  .flex3 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }
}

.success {
  font-size: 16px;

  p {
    margin-top: 24px;
    padding-left: 24px;

    b {
      font-size: 20px;
      font-weight: 700;
      color: #67C23A;
    }
  }
}
</style>